exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-title h4 {\n  text-align: center;\n  width: 210px;\n  margin: 0;\n  background: #007cbb;\n  color: #fff;\n  display: inline-block;\n  padding-left: 6px;\n  padding-right: 6px;\n  border-radius: 3px; }\n\n.p4 {\n  margin: 0; }\n\n.new {\n  margin: 0;\n  background: #60b515;\n  color: #fff;\n  display: inline-block;\n  padding-left: 6px;\n  padding-right: 6px;\n  border-radius: 3px; }\n\n.itm {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.del-row {\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.add-new-cont {\n  background: #e1f1f6;\n  height: 30px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0; }\n\nselect {\n  min-width: inherit;\n  width: 100%;\n  background: #fff; }\n\n.new {\n  margin-top: 6px;\n  background: #60b515;\n  color: #fff;\n  display: inline-block;\n  padding-left: 6px;\n  padding-right: 6px;\n  border-radius: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/company/notifications/site-notifications/site-notifications.component.scss
// module id = ../../../../../src/app/views/site-admin/company/notifications/site-notifications/site-notifications.component.scss
// module chunks = main